import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Text } from "@oneloop/jopijs";
import translations from "../../../FichaInfo.trans.json";
import Trans from "@/components/shared/Trans";
import style from "../priceProperty.module.scss";
import WrapperEdition from "../../../wrapperEdition/WrapperEdition";
import { setToogleEditionValue } from "@/store/slices/components/fichaInfo/FichaInfoSlice";

export default function OperationEditionCard({ op, index, twoRow }) {
  const { origin_data, edited_data, disabledOperationOff } = useSelector(
    (estado) => estado.FichaInfoSlice
  );

  let editedOpKey = `show_operation_${op.toLocaleLowerCase()}`;
  if (op.toLocaleLowerCase() === "temporary") editedOpKey += "_rent";

  const dispatch = useDispatch();

  const OperationsName = {
    Sale: Trans(translations, "Sale"),
    Rent: Trans(translations, "Rent"),
    Temporary: Trans(translations, "Temporary"),
  };

  return (
    <WrapperEdition
      title={OperationsName[op]}
      enabled={edited_data[editedOpKey]}
      handleShow={() => dispatch(setToogleEditionValue(editedOpKey))}
      disabledOff={disabledOperationOff}
      typeOfData="operations"
    >
      <Box
        data-enabled={edited_data[editedOpKey]}
        data-testid="operations-card"
        key={op + index}
        className={style.pricePropertyItem}
      >
        <Box as="span" className={style.typeOperationTag}>
          {OperationsName[op]}
        </Box>
        {Array(2)
          .fill()
          .map((el, i) => (
            <Box key={`${el}${i}`} className={style.priceCointainer}>
              <Text
                key={i}
                className={style.price}
                variant="bodyBold.fontSize20"
              >
                {origin_data.operations[op][i] || (twoRow ? "-" : null)}
              </Text>
            </Box>
          ))}
      </Box>{" "}
    </WrapperEdition>
  );
}
